import { db } from "../../../config/firebaseconfig";

/**
 * Fetches the data we need to begin uploading a data CSV
 * @param {string} recordId The school id
 * @param {string} assessmentId The assessment id
 * @returns {object} Returns the school, its district, and the assessment objects
 */
export default function initUploadCSV (recordId, assessmentId) {
  if (!recordId || !assessmentId) {
    return Promise.reject(Error('missing parameter'))
  }
  let data = {}
  const getDistrictAndSchool = db.collection('schools').doc(recordId).get()
    .then(schoolDoc => {
      if (!schoolDoc.exists) throw Error('School does not exist.')
      const school = schoolDoc.data()
      data.school = school
      return db.collection('districts').doc(school.district).get()
    })
    .then((doc) => {
      data.district = doc.data()
    })
  const getAssessment = db.collection('sets').doc(assessmentId).get()
    .then(assessmentDoc => {
      if (!assessmentDoc.exists) throw Error('Assessment does not exist.')
      data.assessment = assessmentDoc.data()
    })
  return Promise.all([getDistrictAndSchool, getAssessment])
    .then(() => data)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/initUploadCSV.js